import {allowedDomains} from "~/utils/getThemeFromUrl";
import {defineNuxtRouteMiddleware, navigateTo, useNuxtApp} from '#imports';

export default defineNuxtRouteMiddleware((to) => {
    const nuxtApp = useNuxtApp();
    const store = nuxtApp.$vuex;
    const auth = store?.state?.auth;

    const theme = to.path.replace(/\//g, "");
    const isAProperTheme = allowedDomains.includes(theme);
    const resolvedTheme = isAProperTheme ? theme : 'app';

    const hasTimedOut = auth?.user?.hasTimedOut ?? false;
    if (auth?.loggedIn && !hasTimedOut) {
        return navigateTo('/redirector');
    }

    return navigateTo(`/${resolvedTheme}/login`);
});
